export const
  baseUrl = (process.env.REACT_APP_API_URL as string),
  SessionTypes = ['learner', 'teaching', 'research', 'other'] as const
